import { createFileRoute } from '@tanstack/react-router'
import MoveFolderModal from '../../../../../../../../containers/plan-menu/components/move-items-modals/move-folder-modal'
import { plansMoveSearchSchema } from '../../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/move/folder/$itemId/'
)({
  validateSearch: plansMoveSearchSchema,
  component: MoveFolderModal
})
